import { useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';

import {
  resetFlow,
  setProduct,
  setRecipient,
  setIsDonation,
  provideStatuses,
  setActiveStatus,
  setCountryId,
  setHashId,
} from '../store/giftFlow/giftFlow.actions';
import {
  getGiftCountryId,
  getGiftHashId,
  getGiftProduct,
  getIsGift,
  getIsGiftInfoLoaded,
  getShouldResetFlow,
} from '../store/data/data.selectors';
import { getStatuses, getIsLoaded } from '../store/statuses/statuses.selectors';
import { setShouldResetFlow } from '../store/data/data.actions';
import { GIFT_FLOW_RLP_ID } from '../../../constants/giftFlow.constants';
import { getIsFulfilled, getRecipientState } from '../../../store/users/users.selectors';

export default () => {
  const dispatch = useDispatch();
  const hashId = useSelector(getGiftHashId);
  const product = useSelector(getGiftProduct);
  const isGift = useSelector(getIsGift);
  const isGiftInfoLoaded = useSelector(getIsGiftInfoLoaded);
  const countryId = useSelector(getGiftCountryId);
  const shouldResetFlow = useSelector(getShouldResetFlow);

  const recipient = useSelector(getRecipientState);
  const isUsersFulfilled = useSelector(getIsFulfilled);

  const statuses = useSelector(getStatuses);
  const isStatusesLoaded = useSelector(getIsLoaded);

  const isDataLoaded = isGiftInfoLoaded && isUsersFulfilled && isStatusesLoaded;

  useEffect(() => {
    if (shouldResetFlow && isDataLoaded) {
      batch(() => {
        dispatch(resetFlow());
        dispatch(setShouldResetFlow(false));
      });
    }

    if (isDataLoaded) {
      batch(() => {
        dispatch(setActiveStatus(GIFT_FLOW_RLP_ID));
        dispatch(
          provideStatuses({
            hashId,
            flags: statuses,
            flowProduct: product,
            sendProduct: product,
            isDonationFlow: product.isDonation,
            activeStatus: GIFT_FLOW_RLP_ID,
            isGift,
          }),
        );
        dispatch(setProduct({ ...product, fromMarketplace: false }));
        dispatch(setRecipient(recipient));
        dispatch(setIsDonation(product.isDonation));
        dispatch(setHashId(hashId));
        dispatch(setCountryId(countryId));
      });
    }
  }, [isDataLoaded, hashId, product, recipient, statuses, isGift, countryId, shouldResetFlow, dispatch]);
};
